<script setup lang="ts">
    import { useEvent } from '~/composables/useEventBus';
    import InvoiceRoute from '~/classes/InvoiceRoute';
    import { INVOICE_TYPES, navigateToEntity } from '~/utils/aiEntityMeta';

    const props = defineProps<{
        type: string;
        id: string;
        invoiceStatus?: string;
        invoiceDocumentType?: string;
    }>();

    const emit = defineEmits<{
        preview: [];
    }>();

    const isInvoiceType = computed(() => (INVOICE_TYPES as readonly string[]).includes(props.type));

    const canSend = computed(() => {
        return isInvoiceType.value && props.invoiceStatus === 'draft';
    });

    const canPreview = computed(() => isInvoiceType.value);

    const sendDocument = () => {
        const docType = props.invoiceDocumentType ?? props.type;
        const route = new InvoiceRoute(docType);
        navigateTo({
            path: route.send(props.id),
            query: { email: '1' },
        });
    };

    const openEntity = () => {
        navigateToEntity(props.invoiceDocumentType ?? props.type, props.id);
    };

    const openClosureReport = () => {
        useEvent('worksite:worksite:closure-report:form-modal:open', {});
    };

    const openHeavyPreview = () => emit('preview');
</script>

<template>
    <div class="flex items-center gap-1.5">
        <button
            v-if="canSend"
            class="inline-flex items-center justify-center gap-1.5 h-[31px] px-3 text-[13px] font-medium leading-none text-black bg-[#FFC400] hover:bg-[#FFD02A] border border-[#E8B102] rounded-md shadow-[0_1px_2px_0_rgba(0,0,0,0.08)] transition-colors cursor-pointer"
            @click="sendDocument"
        >
            <i class="fa-solid fa-paper-plane text-[12px]" />
            {{ $t('actions.send') }}
        </button>
        <button
            v-if="canPreview"
            class="inline-flex items-center justify-center gap-1.5 h-[31px] px-3 text-[13px] font-medium leading-none text-[#42484E] bg-white hover:bg-gray-50 border border-[#D3D2D2] rounded-md shadow-[0_1px_2px_0_rgba(0,0,0,0.08)] transition-colors cursor-pointer"
            :title="$t('actions.preview')"
            @click="openHeavyPreview"
        >
            <i class="fa-regular fa-eye text-[12px]" />
        </button>
        <button
            class="inline-flex items-center justify-center gap-1.5 h-[31px] px-3 text-[13px] font-medium leading-none text-[#42484E] bg-white hover:bg-gray-50 border border-[#D3D2D2] rounded-md shadow-[0_1px_2px_0_rgba(0,0,0,0.08)] transition-colors cursor-pointer"
            @click="openEntity"
        >
            <i class="fa-solid fa-arrow-up-right-from-square text-[12px]" />
            {{ $t('actions.open') }}
        </button>
        <button
            v-if="type === 'worksite'"
            class="inline-flex items-center justify-center gap-1.5 h-[31px] px-3 text-[13px] font-medium leading-none text-[#42484E] bg-white hover:bg-gray-50 border border-[#D3D2D2] rounded-md shadow-[0_1px_2px_0_rgba(0,0,0,0.08)] transition-colors cursor-pointer"
            @click="openClosureReport"
        >
            <i class="fa-solid fa-file-lines text-[12px]" />
            PV de réception
        </button>
    </div>
</template>
